<div class="employeeProfile">
	<div class="employeeProfileLeftRow">
		<p class="idText">ID: {{ matchingEmployee.id }}</p>
		<a href="employee-edit/{{ employeeID }}" target="_blank" class="employeeLink">
			<p class="employeeLinkText">{{ employeeName }}, {{ employeeBU }}</p>
		</a>
		<div class="employeeCanvasContainer" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
			<app-highcharts-chart class="employeeProfileMatchChart" [options]="employeeProfileMatchChartOptions">
			</app-highcharts-chart>
			<div class="profile-picture-container" #profilePictureContainer>
				<app-profile-picture class="profile-picture-component" [email]="this.email"> </app-profile-picture>
			</div>
		</div>
		@if (showEvaluation) {
			<p>Fulfillment: {{ matchingEmployee?.evaluation?.overallFulfillment }}%</p>
		}
	</div>
	<div class="employeeProfileRightRow" #employeeProfileRightRow>
		@if (!showEvaluation) {
			<span class="nofulfillment-span">
				{{ _lang("no-fulfillment-generated") }}
			</span>
		}
		<div class="skillFulfillmentCanvasDiv">
			<app-highcharts-chart class="skillFulfillmentChart" [options]="skillEvaluationChartOptions">
			</app-highcharts-chart>
		</div>
	</div>
	@if (showSkillDbTooltip && employee?.skillDbRows?.length > 0) {
		<div
			class="skillDb-tooltip"
			[style.top.px]="tooltipTop"
			[style.left.px]="tooltipLeft"
			[style.width.px]="tooltipWidth"
			(mouseenter)="onTooltipMouseEnter()"
			(mouseleave)="onTooltipMouseLeave()"
		>
			<app-skill-db-list [employeeId]="employee.id" (mouseleave)="onMouseLeave()"></app-skill-db-list>
		</div>
	}
</div>
